import React from "react";
import { CodeVerification } from "../../ui/Form/CodeVerification";
import PropTypes from "prop-types";
import _Button from "../../generic/_Button";
import { useMutation } from "@tanstack/react-query";
import { ErrorMessage, SuccessMessage } from "../../../utils/toastify";
import useCountTime from "./hooks/useCountTime";
import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import { useAuth } from "../../../Context/AuthContext";

const SendCode = ({ formik }) => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const { time } = useCountTime({
    initialTime: 30,
    reset: formik.values.resetCode,
  });

  const maskString = (string) => {
    if (!string || typeof string !== "string") return;
    if (string) {
      return string.replace(/.(?=.{3})/g, "*");
    }
  };

  const { mutate: verifyCode } = useMutation({
    mutationKey: ["verifyCode"],
    mutationFn: async () => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}users/verify2faCode`,
        {
          code: formik.values.code,
          uuid: formik.values.uuid,
        },
        token,
      );

      return await response.data;
    },
    onSuccess: (data) => {
      console.log(data);
      if (data?.statusCode === 400 || data?.body?.error === "invalid_otp") {
        formik.setFieldValue("attempts", formik.values.attempts + 1);
        ErrorMessage("Código de verificación inválido");
        return;
      }
      formik.setFieldValue("code", "");
      formik.setFieldValue("resetCode", true);
      formik.setFieldValue("step", "VERIFIED");
      auth.updateUserData({
        b_2faenabled: true,
        vc_phone: formik.values.phone,
      });
      SuccessMessage("Se verificó el código de verificación");
    },
    onError: (error) => {
      console.log(error);
      ErrorMessage("Error al enviar el código de verificación");
    },
  });

  const { mutate: resendCode } = useMutation({
    mutationKey: ["resendCode"],
    mutationFn: async () => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}users/resendcode`,
        {
          uuid: formik.values.uuid,
        },
        token,
      );
      return await response.data;
    },
    onSuccess: ({ body }) => {
      if (body?.statusCode === 400 || body?.error === "invalid_otp") {
        formik.setFieldValue("attempts", formik.values.attempts + 1);
        ErrorMessage("Código de verificación inválido");
        return;
      }
      formik.setFieldValue("resetCode", true);
      SuccessMessage("Se reenvió el código de verificación");
    },
    onError: (error) => {
      console.log(error);
      ErrorMessage("Error al enviar el código de verificación");
    },
  });
  return (
    <div className="py-3 ease-in-out duration-300">
      {" "}
      <div className="border px-4 py-4 rounded-lg bg-white">
        Enviamos un código de 6 dígitos a{" "}
        <b>{maskString(formik.values.phone)}</b>
      </div>
      <div className="flex justify-center items-center px-3 py-3">
        <CodeVerification
          value={formik.values.code}
          onChange={(e) => formik.setFieldValue("code", e)}
          reset={formik.values.resetCode}
        />
      </div>
      <_Button
        style="primary"
        title="Verificar código"
        className="w-full"
        onClick={verifyCode}
        disabled={formik.values.attempts === 3 || !formik.values.code}
      />
      <div className="flex justify-between mt-2">
        <_Button
          disabled={formik.values.attempts === 3 || time > 0}
          onClick={resendCode}
          style="none"
          icon="refresh"
          title={`Reenviar código ${
            time > 0 ? `en ${time} segundos` : "ahora"
          }`}
        />

        <_Button
          onClick={() => {
            formik.setFieldValue("step", "INIT");
            formik.setFieldValue("phone", "");
            formik.setFieldValue("code", "");
            formik.setFieldValue("resetCode", false);
          }}
          style="none"
          icon="edit"
          title="Cambiar número"
        />
      </div>
    </div>
  );
};

SendCode.propTypes = {
  formik: PropTypes.object,
};

export default SendCode;
